import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, AfterViewChecked, OnDestroy } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { UntypedFormGroup, FormGroupDirective, NgForm, UntypedFormControl, Validators, ValidationErrors, UntypedFormBuilder, Form, FormArray } from '@angular/forms';
import { ReportUserDataModel, ReportUser } from '@src/models/reportUser.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import {MatDialog} from '@angular/material/dialog';
import { PopupConfirmComponent } from '@src/app/components/popup-confirm/popup-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { ReportService } from '@src/app/services/reportService.service';
import {merge, Observable, of as observableOf, Subscription} from 'rxjs';
import {catchError, map, startWith, switchMap, finalize} from 'rxjs/operators';
import {PageEvent} from '@angular/material/paginator';
import { PopupInfoComponent } from '../popup-info/popup-info.component';
import { FilterModel, UserFilterModel } from '@src/models/filter.model';
import { Sort } from '@angular/material/sort';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { SpecificTrainingModel } from '@src/models/specificTraining.model';
import { HeaderComponent } from '../header/header.component';
import Utils from '@src/app/helpers/Utils';
import { ErrorStateMatcher } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { environment } from '../../../environments/environment';
import { KbwUpdateUserModel } from '@src/models/kbwUpdateUser.model';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    providers: [ReportService],
    standalone: false
})
export class ReportComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild(HeaderComponent)
  private headerComp: HeaderComponent;
  isMobile: boolean;
  private dataSub?: Subscription;
  private sortResetSub?: Subscription;

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
    this.sortResetSub?.unsubscribe();
  }
  panelOpenState = true;
  columnsToDisplay = ['firstName', 'lastName', 'customerIdentifier'];
  columnsToDisplayKbwLast = ['firstName', 'lastName', 'customerIdentifier', 'companyName'];
  

  //dataSource = new MatTableDataSource(ELEMENT_DATA);
  expandedElement: ReportUserDataModel | null;

  pageSize = 25;
  pageSizeOptions: number[] = [2, 10, 25, 100];
  resultsLength = 0;
  matcher = new MyErrorStateMatcher();

  isLoadingResults = true;
  isRateLimitReached = false;
  data: ReportUserDataModel[];
  kbwLastData: ReportUserDataModel[];
  sortedData: ReportUserDataModel[];
  isLoadnig = true;
  minDate: Date;
  maxDate: Date;
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  isKbw = Utils.getBookType() === "KBW";
  editUserForm: UntypedFormGroup;
  // get editUserList() {
  //   return this.editUserFormTable.get('editUserList') as FormArray;
  // }


  @ViewChild('mainPaginator', {static:true}) paginator: MatPaginator;
  @ViewChild('mainSort', {static: true}) sort: MatSort;
  constructor(
    private reportService: ReportService,
    private translate: TranslateService,
    private deviceService: DeviceDetectorService,
    public dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private dateAdapter: DateAdapter<any>,
    private cdr: ChangeDetectorRef) {
      console.log('typ ' + this.isKbw);
      const currentYear = new Date().getFullYear();
      this.minDate = new Date(currentYear - 80, 0, 1);
      this.maxDate = new Date(currentYear - 14, 0, 1);
      let envLang = sessionStorage.getItem(environment.sessionLang);
      // Find the position of the hyphen
      if(envLang == null){
        envLang = 'pl-PL';
      }
      let hyphenIndex = envLang.indexOf('-');

      // Extract characters up to the first hyphen
      let lang = hyphenIndex !== -1 ? envLang.substring(0, hyphenIndex) : envLang;

      this.dateAdapter.setLocale(lang);
      this.editUserForm = this.formBuilder.group({
        userId: new UntypedFormControl(''),
        firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
        lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
        customerIdentifier: new UntypedFormControl('', [Validators.required, Validators.minLength(2)])
      });
      if(!this.isKbw){
        this.columnsToDisplay.push('documentNumber');
      } else {
        this.columnsToDisplay.push('companyName');
      }
      this.columnsToDisplay.push('id');
   }
  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }
  ngAfterViewInit(): void {
    this.headerComp.logoutBtn = true;
    this.refreshDataSource();
  }
  tabChanged($event){
    if(this.isKbw && $event.index === 1){
      this.refreshKbwLast();
    }
  }

  onRowClicked(element: any) {
    this.expandedElement = this.expandedElement === element ? null : element;
    if (this.expandedElement) {
      this.editUserForm.patchValue({
        userId: element.userId,
        firstName: element.firstName,
        lastName: element.lastName,
        customerIdentifier: element.customerIdentifier
      });
    }
  }

  search(userFilter: UserFilterModel) {
    this.paginator.pageIndex = 0;
    const filter: FilterModel = {
      pageIndex: this.paginator.pageIndex,
      pageSize: this.pageSize,
      sortActive: this.sort.active,
      sortDirection: (this.sort.direction === 'desc') ? 1 : 0,
      userFilter: userFilter
    };
    this.refreshDataSource(filter);
  }
  private refreshKbwLast(){
    this.reportService.getKbwLast(10).subscribe((res) => { 
      this.kbwLastData = res.items;
     });
  }

  private refreshDataSource(qFilter: FilterModel = null) {
    let filter: FilterModel;
    // if(this.isKbw && qFilter != null && qFilter.userFilter != null && qFilter.userFilter.customerIdentifier.toLowerCase().includes('nan') )
    //   {
    //     qFilter.userFilter.customerIdentifier = '';
    //   }
    if (!qFilter) {
      filter = {
        pageIndex: this.paginator.pageIndex,
        pageSize: this.pageSize,
        sortActive: this.sort.active,
        sortDirection: (this.sort.direction === 'desc') ? 1 : 0,
        userFilter: {
          documentNr: '',
          firstName: '',
          lastName: '',
          customerIdentifier: '',
          companyName: ''
        }
      };
    } else {
      filter = qFilter;
    }

    this.dataSub?.unsubscribe();
    this.sortResetSub?.unsubscribe();

      this.sortResetSub = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
//    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.dataSub = merge(this.sort.sortChange, this.paginator.page)
    .pipe(
      startWith({}),
      switchMap((m, n) => {
        this.isLoadnig = true;
        this.isLoadingResults = true;
        filter.pageIndex = this.paginator.pageIndex;
        filter.sortDirection = (this.sort.direction === 'desc') ? 1 : 0;
        //filter.pageIndex = qFilter.pageIndex;
        //filter.sortDirection = qFilter.sortDirection;
        //filter.sortActive = qFilter.sortActive;
        //filter.pageSize = qFilter.pageSize;
        filter.sortActive = this.sort.active;
        filter.pageSize = this.pageSize;
        return this.reportService.getUsers(filter);
      }),
      map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = data.totalCount;

        return data.items;
      }),
      catchError((err) => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        return observableOf([]);
      }),
      finalize(() => {
        this.isLoadnig = false;
        this.isLoadingResults = false;
      })
    ).subscribe(
      (data) => {
      this.data = data;
      this.sortedData = data.slice();
      this.isLoadnig = false;
      // for (let i = 0; i < this.data.length; i++) {
      //   this.editUserList.push(
      //     this.formBuilder.group({
      //       firstName: new FormControl(),//.patchValue('dd'),
      //       lastName: new FormControl(),
      //     })
      //   );
      // }
     },
     (err) => {
      this.isLoadnig = false;
     },
     () => {
       this.isLoadnig = false;
      }
     );
  }
  updateUser(){
    let acceptRemove;
    this.translate.get('ChangeUserData').subscribe((data: any) => {
      acceptRemove = data;
    });
    const dialogRef = this.dialog.open(PopupConfirmComponent, {
      data: { message: acceptRemove }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      let actionSuccess;
      let custIdentf;
      if (confirm === true) {
        if(Utils.getBookType() === 'KBW'){
          custIdentf = Utils.convertDate(this.editUserForm.value.customerIdentifier);
        }
        const userModel: KbwUpdateUserModel = {
          firstName: this.editUserForm.value.firstName,
          lastName: this.editUserForm.value.lastName,
          userId: this.editUserForm.value.userId,
          customerIdentifier: custIdentf
        }
        console.log(userModel);
        this.reportService.updateKbwUserData(userModel).subscribe((p) => {
          this.refreshDataSource();
          this.translate.get('OperationSuccess').subscribe((data: any) => {
            actionSuccess = data;
          });
          this.dialog.open(PopupInfoComponent, {
            data: { message: actionSuccess, infoType: 'success' }
          });
        },
        (error) => {
          this.translate.get('OperationError').subscribe((data: any) => {
            actionSuccess = data;
          });
          this.dialog.open(PopupInfoComponent, {
            data: { message: actionSuccess, infoType: 'error' }
          });
        },
        () => {

        });
      }
    });
    console.log(this.editUserForm.value);
  }
  clearField(name){
    this.editUserForm.get(name).reset('');
  }

  sortData(sort: Sort) {
    let dt = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = dt;
      return;
    }

    this.sortedData = dt.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'firstName': return compare(a.firstName, b.firstName, isAsc);
        case 'lastName': return compare(a.lastName, b.lastName, isAsc);
        case 'documentNumber': return compare(a.documentNumber, b.documentNumber, isAsc);
        case 'customerIdentifier': return compare(a.customerIdentifier, b.customerIdentifier, isAsc);
        case 'companyName': return compare(a.companyName, b.companyName, isAsc);
        default: return 0;
      }
    });
  }


  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    // this.dataSource.sort = this.sort;
  }
  onRemoveAll(event, user) {
    let acceptRemove;
    this.translate.get('RemoveAllConfirm').subscribe((data: any) => {
      acceptRemove = data;
    });
    const dialogRef = this.dialog.open(PopupConfirmComponent, {
      data: { message: acceptRemove }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      let actionSuccess;
      if (confirm === true) {
        this.reportService.removeAllTrainings(user.userId).subscribe((p) => {
          this.refreshDataSource();
          this.translate.get('OperationSuccess').subscribe((data: any) => {
            actionSuccess = data;
          });
          this.dialog.open(PopupInfoComponent, {
            data: { message: actionSuccess, infoType: 'success' }
          });
        },
        (error) => {
          this.translate.get('OperationError').subscribe((data: any) => {
            actionSuccess = data;
          });
          this.dialog.open(PopupInfoComponent, {
            data: { message: actionSuccess, infoType: 'error' }
          });
        },
        () => {

        });
      }
    });
  }
  onRemoveOne(userId, trainingId) {
    let acceptRemove;
    this.translate.get('RemoveTrainingConfirm').subscribe((data: any) => {
      acceptRemove = data;
    });
    const dialogRef = this.dialog.open(PopupConfirmComponent, {
      data: { message: acceptRemove }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      let actionSuccess;
      if (confirm === true) {
        const specificTraining: SpecificTrainingModel = {
          trainingId: trainingId,
          userId: userId
        };
        this.reportService.removeSpecificTraining(specificTraining).subscribe((p) => {
          this.refreshDataSource();
          this.translate.get('OperationSuccess').subscribe((data: any) => {
            actionSuccess = data;
          });
          this.dialog.open(PopupInfoComponent, {
            data: { message: actionSuccess, infoType: 'success' }
          });
        },
        (error) => {
          this.translate.get('OperationError').subscribe((data: any) => {
            actionSuccess = data;
          });
          this.dialog.open(PopupInfoComponent, {
            data: { message: actionSuccess, infoType: 'error' }
          });
        },
        () => {

        });
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
